/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerPaymentInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CustomerPaymentInfoQuery = {
  readonly __typename?: 'Query';
  readonly customerPaymentInfo: {
    readonly __typename: 'CustomerPaymentInfo';
    readonly id: string;
    readonly paymentEphemeralKey: string;
    readonly paymentSessionId: string;
  };
};

export const CustomerPaymentInfoDocument = gql`
  query CustomerPaymentInfo {
    customerPaymentInfo {
      id
      paymentEphemeralKey
      paymentSessionId
      __typename
    }
  }
`;

export function useCustomerPaymentInfoQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerPaymentInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerPaymentInfoQuery, CustomerPaymentInfoQueryVariables>({
    query: CustomerPaymentInfoDocument,
    ...options,
  });
}
